import { useTranslation } from 'react-i18next';

import FormWithProvider from 'components/forms/form/Form';
import FormFieldset from 'components/forms/form/FormFieldset';
import TextField from 'components/forms/textField/TextField';
import ModalFormFooter from 'components/modal/form/ModalFormFooter';
import { InternalIntegrationSetting } from 'models/InternalIntegrationSetting';
import { ModalBody, Row } from 'react-bootstrap';
import {
  editRateMultiplierFormSchema,
  getFormDefaultValues,
} from './EditRateMultiplierModal.schema';
import useEditRateMultiplierModalFormSubmit from './useEditRateMultiplierModalFormSubmit';

interface EditRateMultiplierModalProps {
  integrationSettings: InternalIntegrationSetting;
}

const EditRateMultiplierModal = ({
  integrationSettings,
}: EditRateMultiplierModalProps) => {
  const { t } = useTranslation();
  const { onSubmit } = useEditRateMultiplierModalFormSubmit({
    integrationSettings,
  });

  return (
    <FormWithProvider
      defaultValues={getFormDefaultValues({ integrationSettings })}
      onSubmit={onSubmit}
      resolver={editRateMultiplierFormSchema()}
      noValidate
    >
      <ModalBody>
        <FormFieldset>
          <Row className="d-flex flex-column">
            <TextField
              label={t('pageChannels.modals.editRateMultiplier.rateMultiplier')}
              name="rateMultiplier"
              colSmInput={8}
              colSmLabel={4}
              step="any"
              type="number"
              rightAddons={['%']}
              rightTooltip={t(
                'pageChannels.modals.editRateMultiplier.rateMultiplierTooltip',
              )}
              rightTooltipPlacement="bottom"
              required
            />
          </Row>
        </FormFieldset>
      </ModalBody>
      <ModalFormFooter />
    </FormWithProvider>
  );
};

export default EditRateMultiplierModal;
